export default class PlatformMap {
  constructor(block) {
    this.block = block;
    this.dropdown = block.querySelector(".platform-map__dropdown");
    this.dataType = this.dropdown?.getAttribute("data-type");

    this.searchInput = block.querySelector(".search-list__input");
    this.countryList = block.querySelector(".search-list__list");

    this.map = block.querySelector(".platform-map__map");
    this.modal = block.querySelector(".map-modal");
    this.closeModalBtn = block.querySelector(".map-modal__close");

    this.init();
  }

  init() {
    this.setupDropdown();
    this.setupSearchList();
    this.setupMapEvents();
    this.setupModal();
    this.preset();
  }

  closeModal() {
    this.modal.classList.add("map-modal--hidden");
    this.activateCountries(this.dropdown.value);
  }

  preset() {
    if (this.dropdown[this.dropdown.selectedIndex].disabled) return;

    this.activateCountries(this.dropdown.value);
  }

  setupDropdown() {
    this.dropdown.addEventListener("change", (ev) => {
      const value = ev.target.value;
      this.activateCountries(value);
      this.showMap();
    });
  }

  showMap() {
    this.modal.classList.add("map-modal--hidden");
    this.map.classList.remove("platform-map__map--hidden");
  }

  activateCountries(value) {
    this.searchInput.value = "";
    if (value.toLowerCase().startsWith("choose")) {
      // Reset all
      for (const country of this.countryList.children) {
        country.classList.remove("search-list__item--hidden");
        country.classList.remove("search-list__item--fade");
        country.removeAttribute("style");
        country.removeAttribute("inert");
        const highlighted = this.map.querySelector(".highlight");
        if (highlighted) {
          highlighted.classList.remove("highlight");
        }
      }
    } else {
      for (const country of this.countryList.children) {
        country.classList.remove("search-list__item--hidden");
        country.classList.remove("search-list__item--fade");
        country.removeAttribute("inert");
        country.removeAttribute("style");
        if (!country.getAttribute(`data-${this.dataType}`).includes(value)) {
          country.classList.add("search-list__item--hidden");
          country.setAttribute("inert", "");
          const countryInMap = this.map.querySelector(
            `#${country.getAttribute("data-value")}`
          );
          countryInMap.classList.remove("highlight");
        } else {
          country.classList.remove("search-list__item--hidden");
          const countryInMap = this.map.querySelector(
            `#${country.getAttribute("data-value")}`
          );
          if (countryInMap) {
            countryInMap.classList.add("highlight");
          } else {
            console.error(
              "MISSING COUNTRY",
              country.getAttribute("data-value")
            );
          }
        }
      }
    }
  }

  setupSearchList() {
    this.countryFilter();
    this.countryListListener();
  }

  countryListListener() {
    this.countryList.addEventListener("click", (ev) => {
      this.activateCountry(ev.target.parentElement.getAttribute("data-value"));
    });
  }

  activateCountry(countrySlug) {
    const countryItem = this.countryList.querySelector(
      `[data-value=${countrySlug}]`
    );
    if (!countryItem) return;
    // Highlight in list
    for (const child of this.countryList.children) {
      if (
        child
          .querySelector(".search-list__button")
          .parentElement.getAttribute("data-value") == countrySlug
      ) {
        child.classList.remove("search-list__item--fade");
      } else {
        child.classList.add("search-list__item--fade");
      }
    }

    // Highlight in map
    if (window.innerWidth > 1280) {
      const paths = this.map.querySelectorAll("path");
      const countryInMap = this.map.querySelector(`#${countrySlug}`);
      if (countryInMap) {
        paths.forEach((path) => path.classList.remove("highlight"));
        countryInMap.classList.add("highlight");
      }
    } else {
      if (window.innerWidth < 1280) {
        this.map.classList.add("platform-map__map--hidden");
      }
    }

    // Change info modal
    this.modal.querySelector(".platform-country").innerText = countrySlug;
    // Update checked / unchecked
    const platforms = this.modal.querySelectorAll(".map-modal__list-item");
    platforms.forEach((platform) => {
      const slug = platform.getAttribute("data-slug");
      platform.classList.remove("map-modal__list-item--checked");
      if (countryItem.getAttribute(`data-${this.dataType}`).includes(slug)) {
        platform.classList.add("map-modal__list-item--checked");
      }
    });
    // Show Modal
    this.modal.classList.remove("map-modal--hidden");
  }

  countryFilter() {
    this.searchInput.addEventListener("input", (ev) => {
      // Listen to text-input
      const filterString = ev.target.value;
      // filter list
      const items = this.countryList.querySelectorAll("li");

      items.forEach((item) => {
        const text = item.textContent.toLowerCase();
        if (text.includes(filterString)) {
          item.style.display = "";
        } else {
          item.style.display = "none";
        }
      });
    });
  }

  setupModal() {
    this.closeModalBtn.addEventListener("click", () => {
      this.closeModal();
    });
    addEventListener("keydown", (ev) => {
      if (ev.key == "Escape") {
				this.modal.classList.add("map-modal--hidden");
				this.activateCountries(this.dropdown.value);
      }
    });
  }

  setupMapEvents() {
    this.map.addEventListener("click", (ev) => {
      if (ev.target.id) {
        this.activateCountry(ev.target.id);
      } else {
        this.closeModal();
      }
    });
  }
}
